import { RouteElement } from '@components'

import { Route as V6Route, Routes as V6Routes } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { CreateFolderModalProvider } from './contexts/CreateFolderModalContext'
import { DocumentsDragAndDropProvider } from './contexts/DocumentsDragAndDropContext'
import { CreateFolderActionModal } from './elements/CreateFolderActionModal'
import { DocumentMigrationDoneModal } from './elements/DocumentMigrationDoneModal'
import { DocumentsLayout } from './elements/DocumentsLayout'
import { FirstTimeInDocumentsModal } from './elements/FirstTimeInDocumentsModal'
import { useDmsUserRole } from './hooks/useDmsUserRole'
import { DocumentLink } from './routes/DocumentLink'
import { DocumentsEmptyState } from './routes/DocumentsEmptyState'
import { FolderContent } from './routes/FolderContent'
import { SharedByMe } from './routes/SharedByMe'
import { Unsorted } from './routes/UnsortedDocuments'

const Documents = () => {
  const { organization } = useUserOrganization()
  const { role } = useDmsUserRole()

  return (
    <CreateFolderModalProvider>
      <DocumentsDragAndDropProvider>
        <DocumentsLayout>
          {/* No <Switch>: every entry below is mutually exclusive by path already. CompatRoute
            can't be used here: it always wraps its content in a v5 RouterRoute, which does its
            own v5 match against the full, un-stripped pathname - but this area is mounted under
            ViewContainer's non-exact /*-wildcard route (see ViewContainer.tsx), which strips that
            matched prefix before matching here. A relative path satisfies the outer v6 match but
            then fails CompatRoute's inner v5 match (which needs the absolute path), and an
            absolute path fails the outer v6 match instead - neither works. Bare v6
            Route+RouteElement (no v5 layer involved) is the only combination where a single
            relative path works correctly.

            This component is mounted twice under two different wildcard prefixes - as
            ExpertDocuments (.../expert/documents/*) and as ClientDocuments (.../documents/*) -
            so these relative fragments cover both: "unsorted" only ever matches under the
            former, "shared" only ever matches under the latter, and index covers the bare case
            for either. */}
          <V6Routes>
            <V6Route
              path="document/:documentId"
              element={
                <RouteElement>
                  <DocumentLink />
                </RouteElement>
              }
            />
            <V6Route
              index
              element={
                <RouteElement>
                  <DocumentsEmptyState />
                </RouteElement>
              }
            />
            <V6Route
              path="unsorted"
              element={
                <RouteElement>
                  <Unsorted />
                </RouteElement>
              }
            />
            <V6Route
              path="shared"
              element={
                <RouteElement>
                  <SharedByMe />
                </RouteElement>
              }
            />
            <V6Route
              path="folders/:folderId/:slug?"
              element={
                <RouteElement>
                  <FolderContent />
                </RouteElement>
              }
            />
          </V6Routes>
          <DocumentMigrationDoneModal />
          {role && <FirstTimeInDocumentsModal role={role} />}
          <CreateFolderActionModal clientName={organization?.name ?? ''} isCpa={!!organization?.ownerUmbrellaId} />
        </DocumentsLayout>
      </DocumentsDragAndDropProvider>
    </CreateFolderModalProvider>
  )
}

export { Documents }
